export const checkIfReduceMotion = (window: Window): boolean =>
    !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion)').matches);
